// extracted by mini-css-extract-plugin
export default {"fullscreen":"ds_fullscreen__B6ROB"};